import React, { useEffect } from 'react'

const AppRedirect = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || window.opera
    const isIOSOrMac =
      /iPad|iPhone|iPod|Macintosh|Mac OS X/i.test(userAgent) && !window.MSStream
    const isAndroid = /android/i.test(userAgent)

    if (isIOSOrMac) {
      window.location.href = 'https://apps.apple.com/in/app/scopex/id6456889025'
    } else if (isAndroid) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.scopex.scopexmobile'
    } else {
      window.location.href = 'https://scopex.money'
    }
  }, [])

  return (
    <div className='h-screen flex justify-center items-center'>
      <h1>Redirecting...</h1>
    </div>
  )
}

export default AppRedirect
